import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const CenterDot = () => /*#__PURE__*/_jsx("span", {
  style: {
    paddingRight: '8px',
    paddingLeft: '8px'
  },
  "aria-hidden": true,
  children: "\xB7"
});